var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 834,
    height: 840,
    viewBox: "0 0 834 840",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H834V840H0V0Z",
    fill: "url(#paint0_linear_456_27507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_456_27507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 656,
    height: 840
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H656V840H0V0Z",
    fill: "url(#paint1_linear_456_27507)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_456_27507)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-58.8252 386.996V297.189L-1.12918 340.484L-12.3467 455.95L505.261 962.718L619.039 842.441L82.2008 306.806L112.648 265.115C77.9275 233.577 -12.668 153.5 -97.283 85.503C-181.898 17.5063 -265.012 212.195 -295.992 318.039L-260.743 265.115L-97.283 425.485L-58.8252 386.996Z",
    fill: "url(#paint2_linear_456_27507)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.36 386.996V297.189L328.664 340.484L339.882 455.95L-177.726 962.718L-291.503 842.441L245.334 306.806L214.887 265.115C249.608 233.577 340.203 153.5 424.818 85.503C509.433 17.5063 592.547 212.195 623.527 318.039L588.278 265.115L424.818 425.485L386.36 386.996Z",
    fill: "url(#paint3_linear_456_27507)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_456_27507",
    x1: 164.188,
    y1: 380.917,
    x2: 1182.67,
    y2: 890.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2E33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_456_27507",
    x1: 168.467,
    y1: 380.917,
    x2: 1202.58,
    y2: 911.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2E33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_456_27507",
    x1: 287.573,
    y1: 190.561,
    x2: -22.1317,
    y2: 921.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4147",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_456_27507",
    x1: 39.9617,
    y1: 190.561,
    x2: 349.667,
    y2: 921.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4147",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBg);
export default __webpack_public_path__ + "static/media/Contact-bg.2cf28f052b7aeebc891faa4bd3ffab33.svg";
export { ForwardRef as ReactComponent };